/*
 * PauseScreen
 * ==========
 */

import ScreenBase from '../ui/ScreenBase'

export default class FakePauseScreen extends ScreenBase {

  constructor (game, screens) {
    super(game, 'pause');

    this.screens = screens;

    this.params = {
      'bg': [0, 0],
      'currentScore': [-280 / 2, -155 / 2],
      'currentScoreVal': [280 / 2, -155 / 2],
      'bestScore': [-280 / 2, -95 / 2],
      'bestScoreVal': [280 / 2, -95 / 2],
      'highestLevel': [-280 / 2, -35 / 2],
      'highestLevelVal': [280 / 2, -35 / 2],
      'bestWord': [-280 / 2, 25 / 2],
      'bestWordVal': [280 / 2, 25 / 2],
      'bestWordScore': [-280 / 2, 85 / 2],
      'bestWordScoreVal': [280 / 2, 85 / 2],
      'linesCleared': [-280 / 2, 145 / 2],
      'linesClearedVal': [280 / 2, 145 / 2],
      'title': [0 / 2, -268 / 2],
      'subtitle': [0 / 2, -220 / 2],
      'continue': [0 / 2, 250 / 2]
    }
  }

  onShowStarted () {
    super.onShowStarted()
  }

  onHideEnded () {
    GS.resume();
    super.onHideEnded()
  }
}
